import React from "react";
import { useState,useEffect } from "react";
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import './classes/CancelledPaymentsReport.css';
 import { DataGrid } from '@mui/x-data-grid';
 import { configData } from "../config";
 import { Link } from '@mui/material';
import Loading from './Loading';
import SalespersonSidebar from "./SalespersonSidebar";



    const columns = [
    {
    field: 'order_id',
    headerName: 'Order #',
    cellClassName:'order_id_column',headerClassName:'order_id_header',  
    flex:1,  
    sortable:false,
    minWidth:80,
      renderCell: (params) => (
        <Link href={params.row.order_link} target="_blank" rel="noopener noreferrer" style={{ color: "#2C99D2"}}>
            {params.row.order_id}
          </Link>
      ),
    
  },
  {
    field: 'first_name',
    headerName: 'First Name',  
    headerClassName:'first_name_header',    
    flex:1,
    sortable:false,
    minWidth:98,
  },
  {
    field: 'last_name',
    headerName: 'Last Name',    
    headerClassName:'last_name_header',
    flex:1,
    sortable:false,
    minWidth:94,
  },
    {
    field: 'email',
    headerName: 'Email',
    cellClassName:'email_column',headerClassName:'email_header',   
    flex:1, 
    sortable:false,
    minWidth:347,
    renderCell: (params) => (
        <Link href={params.row.profile_link} target="_blank" rel="noopener noreferrer" style={{ color: "#2C99D2"}}>
            {params.row.email}
          </Link>
      ),
    
  },
  {
    field: 'product_title',
    headerName: 'Product',   
    headerClassName:'country_header',
    flex:1,
    sortable:false,
    minWidth:117,
  },
    {
    field: 'actions',
    headerName: 'Actions',
    cellClassName:'action_column',headerClassName:'action_header',   
    flex:1, 
    sortable:false,
    minWidth:93,
    renderCell: (params) => (
         <div dangerouslySetInnerHTML={{ __html: params.row.subscription_links }} />
    ),
    
  },
  

];

const CancelledPaymentsReport = () => {
    const initialForm = {
        order_id:'',
        email:'',
        fname:'',
        lname:''
    };

    const [isLoading, setIsLoading] = useState(true);
    const [formData, setFormData] = useState(initialForm);   
    const [submittedData, setSubmittedData] = useState(null);
    const [rows, setRows] = React.useState([]);
    const [rowCount, setRowCount] = React.useState(0);
    const [paginationModel, setPaginationModel] = React.useState({ page: 0, pageSize: 50 });
    const [sortModel, setSortModel] = React.useState([]);
    const [filterModel, setFilterModel] = React.useState({ items: [] });

    const app_url = configData.APP_URL;

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };
    const handlePaginationModelChange = (newModel) => {
 
    if (newModel.pageSize !== paginationModel.pageSize) {
        // Reset page to 0 if pageSize changed
        setPaginationModel({ page: 0, pageSize: newModel.pageSize });
        //fetchData(0, newModel.pageSize);
    } else {
        setPaginationModel(newModel);
       // fetchData(newModel.page, newModel.pageSize);
    }
};
    React.useEffect(() => {
       
          const fetchData = async () => {
          // Simulate API call to your server
          // In a real application, replace this with your actual fetch logic
           try {
            setIsLoading(true);
          const response = await fetch(app_url+'report/cancelledpayment', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              page: paginationModel.page,
              pageSize: paginationModel.pageSize,
              sortModel,
              filterModel,
              formData:formData
            }),
          });
          const data = await response.json();
          console.log(data.data.rows);
          setRows(data.data.rows);
          setRowCount(data.data.totalRowCount); // Server should return totalRowCount
          }  catch (error) {
                console.error('Error fetching data:', error);
              } finally {
                setIsLoading(false); // Set loading to false after fetch completes (success or error)
              }
              
        };
        
    
        fetchData();
      
          }, [paginationModel, sortModel, filterModel]); // Re-fetch data when these change 

   
  
 
  // Handle submit
  const handleSubmit = async (e) => {
    e.preventDefault(); 
    setPaginationModel({
                 page: 0,
                    pageSize: paginationModel.pageSize,
                 });
   try {
            setIsLoading(true);
          const response = await fetch(app_url+'report/cancelledpayment', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              page: 0,
              pageSize: 50,
              sortModel,
              filterModel,
              formData:formData
            }),
          });
          const data = await response.json();
          console.log(data.data.rows);
          setRows(data.data.rows);
          setRowCount(data.data.totalRowCount); // Server should return totalRowCount
          }  catch (error) {
                console.error('Error fetching data:', error);
              } finally {
                setIsLoading(false); // Set loading to false after fetch completes (success or error)
              }

  };
   const handleReset = async (e) => {
    setFormData({ order_id: "", email: "", fname: "", lname: "" });
     e.preventDefault(); 
   try {
            setIsLoading(true);
          const response = await fetch(app_url+'report/cancelledpayment', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              page: paginationModel.page,
              pageSize: paginationModel.pageSize,
              sortModel,
              filterModel,
              formData:initialForm
            }),
          });
          const data = await response.json();
          console.log(data.data.rows);
          setRows(data.data.rows);
          setRowCount(data.data.totalRowCount); // Server should return totalRowCount
          }  catch (error) {
                console.error('Error fetching data:', error);
              } finally {
                setIsLoading(false); // Set loading to false after fetch completes (success or error)
              }

  };

    return (
        <>
            {isLoading ? (
                <Loading />
            ) : ( 
                <div id="main">
                    <Helmet><title>SMWW Recurring payment cancelled</title></Helmet>
                    <div className="left"></div>
                    <div className="center left-center">
                        <div  className="cancelled-payments-report-container">
                            <div>
                                <h1>Cancelled Payments Report</h1>
                                <div class="messages warning">
                                     Using the "Change Card" feature on this report will process the payment at the moment you use it. To only update the card, go to the "My Orders" page of the student.
	                             </div>
                                <form >
                                    <fieldset style={{border:0}}>
                                       <b>Search</b><br/>
                                        <div style={{ width: "100%" }}>
                                        <div style={{ width: "50%", float: "left" }}>
                                            <label>Order</label>
                                            <input
                                            type="text"
                                            name="order_id"
                                            value={formData.order_id}
                                            onChange={handleChange}
                                            />
                                            <br />
                                            <br />
                                            <label>Email</label>
                                            <input
                                            type="text"
                                            name="email"
                                            value={formData.email}
                                            onChange={handleChange}
                                            />
                                        </div>

                                        <div style={{ width: "50%", float: "left" }} className="first_last_name_cont">
                                            <label>First Name</label>
                                            <input
                                            type="text"
                                            name="fname"
                                            value={formData.fname}
                                            onChange={handleChange}
                                            />
                                            <br />
                                            <br />
                                            <label>Last Name</label>
                                            <input
                                            type="text"
                                            name="lname"
                                            value={formData.lname}
                                            onChange={handleChange}
                                            />
                                        </div>

                                        <div style={{ clear: "both" }}></div>
                                        <br />
                                        <br />
                                        <input type="submit" value="Submit" onClick={handleSubmit}/>
                                        <input
                                            type="button"
                                            value="Reset"
                                            onClick={handleReset}
                                            style={{ marginLeft: "10px" }}
                                        />
                                        </div>
                                    </fieldset>
             
                                  
                                </form>
                               
                            </div>
                            
                                    <div className="cancelled-payments-report-content">
                                        <table className="cancelled-payments-report-table">
                                            <div style={{ width: '100%' }}>
                                                <DataGrid
                                                    rows={rows}
                                                    columns={columns}
                                                    rowCount={rowCount}
                                                    paginationMode="server"
                                                    sortingMode="server"
                                                    filterMode="server"
                                                    paginationModel={paginationModel}
                                                    onPaginationModelChange={handlePaginationModelChange}
                                                    sortModel={sortModel}
                                                    onSortModelChange={setSortModel}
                                                    filterModel={filterModel}
                                                    onFilterModelChange={setFilterModel}
                                                    pageSizeOptions={[5, 10, 25,50]}
                                                    getRowId={() => crypto.randomUUID()}
                                                    getRowHeight={() => 'auto'}
                                                    disableColumnFilter 
                                                    //disableColumnResize={true}
                                                />
                                            </div>
                                        </table>
                                    </div>
                             
                        </div>
                    </div>
                    <div className="right">
                        <SalespersonSidebar/>
                    </div>
                </div>
            )}
        </>
    );
};
export default CancelledPaymentsReport;